import axios from 'axios';
import * as React from 'react';

import { API_ENDPOINTS } from 'utils/constants';
import { parseError } from 'utils/parseError';
import { SSOProvider } from 'utils/types';

export const useSSOProviderData = (
  provider: string | null
): {
  data: SSOProvider | null;
  error: string | null;
} => {
  const [data, setData] = React.useState<SSOProvider | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (provider) {
      axios
        .get<SSOProvider>(API_ENDPOINTS.SSO_PROVIDERS, {
          params: { q: provider }
        })
        .then((response) => {
          setData(response.data);
          setError(null);
        })
        .catch((responseError) => {
          setData(null);
          setError(parseError(responseError.response.data.error));
        });
    }
  }, [provider]);

  return { data, error };
};
